// extracted by mini-css-extract-plugin
export var linkText = "_np-0";